import type { TFunction } from "i18next";
import U2000DeleteRecordDialog from "../../../../../u2000Core/components/dialog/U2000DeleteRecordDialog";
import type { U3148AffilaitionRoleHandler } from "./U3148AffilaitionRoleHandlers";
import type { U3148AffiliationRole } from "../../../../U3148Service";

// Typage des props du composant
interface U3148AffilaitionRoleDeleteDlgProps {
  u3148AffilaitionRoleHandler: U3148AffilaitionRoleHandler;
  t: TFunction;
  NS: string;
}

function U3148AffilaitionRoleDeleteDlg({ u3148AffilaitionRoleHandler, t, NS }: U3148AffilaitionRoleDeleteDlgProps) {
  // Plus besoin de helpers custom, U2000CheckBoxArray gère tout

  if (!u3148AffilaitionRoleHandler.isDeleteDialogOpen) return null;

  return (
    <U2000DeleteRecordDialog isOpen={u3148AffilaitionRoleHandler.isDeleteDialogOpen} onClose={u3148AffilaitionRoleHandler.onDlgDeleteClose} title={t("lblDeleteDlgTitle", { ns: NS })}>
      <p className="mb-4">
        {t("user.msgDeleteUserRole", {
          count: u3148AffilaitionRoleHandler.gridStateHandlers.getSelectedRows().length,
          ns: NS,
        })}
      </p>
      <div className="mt-2 flex flex-wrap justify-center gap-x-2">
        {u3148AffilaitionRoleHandler.gridStateHandlers.getSelectedRows().map((row, index, array) => {
          const role = row as unknown as U3148AffiliationRole;
          return (
            <span key={role.roleCode} className="inline-block text-gray-800">
              {`${role.roleCode} - ${role.roleDescription}`}
              {index < array.length - 1 && ", "}
            </span>
          );
        })}
      </div>
    </U2000DeleteRecordDialog>
  );
}

export default U3148AffilaitionRoleDeleteDlg;
